import { Button, Form, Input, Modal } from 'antd';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import MyUtil from '../../functions/MyUtil';
export default class ModalHoliday extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      holidays: [],
      holis: '',
    };
  }

  async componentDidMount() {
    var holidays = await PartnerApi.getAllHolidays();
    var holis = this.props.holis ? this.props.holis : '';
    holidays = holidays ? holidays : [];
    var arr = [];
    holidays.forEach((element) => {
      var check = holis.indexOf(element.holi_name) !== -1;
      element = Object.assign(element, {
        checked: check,
        [element['holi_name'] + '_note']: '',
      });
      arr.push(element);
    });

    if (holis !== '' && holis != null) {
      arr = MyUtil.convertManyOption(holis);
    }
    var arrHolidays = [];

    holidays.forEach((element, index) => {
      var check = holis.indexOf(element.holi_name) !== -1;
      var note = arr[element['holi_name']];
      if (holis)
        element = Object.assign(element, {
          checked: check,
          [element['holi_name'] + '_note']: note,
        });
      arrHolidays.push(element);
    });

    this.setState({ holidays: arrHolidays });
  }

  handleChange = (event) => {
    var note = event.target.value;
    var holidays = this.state.holidays;
    if (holidays) {
      holidays.forEach((item, index) => {
        if (item.holi_name + '_note' === event.target.name) {
          holidays[index][event.target.name] = MyUtil.convertMoney(note);
        }
      });
    }
    this.setState({ holidays });
  };

  handleSelectOption = (event) => {
    var holidays = this.state.holidays;
    if (holidays) {
      holidays.forEach((item, index) => {
        if (item.holi_name === event.target.name) {
          holidays[index].checked = event.target.checked;
          return;
        }
      });
      this.setState({ holidays });
    }
  };

  handleSave = () => {
    var holidays = this.state.holidays;
    var holis = '';
    holidays.forEach((item) => {
      if (item.checked) {
        var note = item[item.holi_name + '_note'];
        if (note && note !== '' && note.toString().trim() !== '')
          holis += item.holi_name + ':' + note + ',';
        else holis += item.holi_name + ',';
      }
    });
    if (holis && holis.trim() !== '') {
      holis = holis.substr(0, holis.length - 1);
    }
    this.props.onChangeManyOption('holis', holis);
    this.setState({
      modal: false,
    });
  };

  handleCancel = () => {
    this.setState({
      modal: false,
    });
  };

  render() {
    const { holidays, modal } = this.state;

    return (
      <>
        <Form.Item name={['holis']} label="Giá ngày lễ">
          <Input />
        </Form.Item>
        <Button
          onClick={() => {
            this.setState({
              modal: true,
            });
          }}
        >
          Thêm/Thay đổi
        </Button>

        <Modal
          visible={modal}
          title="Thêm thủ tục của đối tác"
          onOk={this.handleSave}
          onCancel={this.handleCancel}
        >
          <Row className="row-form">
            {Object.keys(holidays).map((key) => {
              return (
                <div
                  key={key}
                  style={{ marginLeft: '20px' }}
                  className="policy-partner"
                >
                  <input
                    name={holidays[key].holi_name}
                    type="checkbox"
                    defaultChecked={holidays[key]['checked']}
                    onChange={this.handleSelectOption}
                  />
                  <div
                    className="lable-option"
                    style={{ width: '180px', display: '-webkit-inline-box' }}
                  >
                    {holidays[key].holi_name}
                  </div>

                  <input
                    disabled={!holidays[key]['checked']}
                    name={holidays[key].holi_name + '_note'}
                    placeholder="% hoặc số tiền"
                    onChange={this.handleChange}
                    className="input-normal"
                    style={{ width: '253px' }}
                    value={
                      holidays[key][holidays[key].holi_name + '_note'] > 1000
                        ? MyUtil.currencyFormat(
                            holidays[key][holidays[key].holi_name + '_note']
                          )
                        : holidays[key][holidays[key].holi_name + '_note']
                    }
                  ></input>
                </div>
              );
            })}
          </Row>
        </Modal>
      </>
    );
  }
}
